import {DesignServicesModel} from './DesignServicesModel';
import {UnitsModel} from './UnitsModel';
import {LayerModel} from './LayerModel';
import {L1Model} from './L1Model';
import {L2Model} from './L2Model';
import {L3Model} from './L3Model';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ProviderModel} from './ProviderModel';
import {SizeModel} from './SizeModel';
import {SiteModel} from './SiteModel';

export class ArchitectureStructureSettingModel {
  id: number;
  units: UnitsModel;
  designServices: DesignServicesModel;
  layer: LayerModel;
  l1: L1Model;
  l2: L2Model;
  l3: L3Model;
  resourceUnit: ResourcesUnitModel;
  provider: ProviderModel;
  size: SizeModel;
  site: SiteModel;

  constructor(id?: number, sl1?: DesignServicesModel, units?: UnitsModel, sl2?: LayerModel,
              sl3?: L1Model, sl4?: L2Model, sl5?: L3Model, resourceUnit?: ResourcesUnitModel, provider?: ProviderModel,
              size?: SizeModel, site?: SiteModel) {
    this.id = id;
    this.designServices = sl1;
    this.units = units;
    this.layer = sl2;
    this.l1 = sl3;
    this.l2 = sl4;
    this.l3 = sl5;
    this.resourceUnit = resourceUnit;
    this.provider = provider;
    this.size = size;
    this.site = site;
  }

  public static clone (obj: ArchitectureStructureSettingModel): ArchitectureStructureSettingModel {
    const result: ArchitectureStructureSettingModel = new ArchitectureStructureSettingModel();

    result.provider = obj.provider;
    result.designServices = obj.designServices;
    result.resourceUnit = obj.resourceUnit;
    result.units = obj.units;
    result.layer = obj.layer;
    result.l1 = obj.l1;
    result.l2 = obj.l2;
    result.l3 = obj.l3;
    result.size = obj.size;
    result.site = obj.site;


    return result;

  }
}
